// export const updateValue = (state, payload) => {
//     state.value = payload
//   }

let mutations = {};

mutations.fn_countPhanHoi = (state) => {
    state.phanHoi.refreshFnCountNew++;
};

mutations.fn_saveCurrentUser = (state) => {
    state.currentUser = JSON.parse(window.localStorage.currentUser);
};

mutations.fn_reloadModalDetailHL7 = (state) => {
    state.reloadModalDetailHL7++;
};

// mutations.fn_saveDataSearchUser = (state, data) => {
//     state.dataSearchUser.data = data;
//     state.dataSearchUser.data = data;
// };

mutations.fn_searchDataSearchUserSuccess = (state, data) => {
    state.dataSearchUser.isResult = true;
    state.dataSearchUser.data = data;
    state.dataSearchUser.reload++;
};

mutations.fn_searchDataSearchUserError = (state) => {
    state.dataSearchUser.isResult = false;
    state.dataSearchUser.data = {};
    state.dataSearchUser.reload++;
};

mutations.fn_saveDataUser = (state,data) => {
    state.dataUser = data;
}

export default mutations;

